// extracted by mini-css-extract-plugin
module.exports = {"Content":"productQuestions_Content__O3IZS"};